import { LayoutAdminTable } from 'app/components/templates/LayoutAdminTable';
import { Helmet } from 'react-helmet-async';
import React from 'react';
import { useInjection } from './hook';
import { PostSeizureForm } from '../../PostSeizurePage/components/modules/FormPostSeizure/FormPostSeizure';

export const EditPreSeizure = () => {
  const { handleOnBack, dataDetail, onSubmitUpdatePreSeizure, generateSeizure } = useInjection();
  return (
    <LayoutAdminTable title={'Pre Seizure'} textButton={'Back'} onClickButton={handleOnBack}>
      <Helmet>
        <title>Surrey Bailiffs - Pre Seizure</title>
      </Helmet>
      <PostSeizureForm
        asyncHandleGenerate={generateSeizure}
        isPre
        isEdit
        initDataForm={dataDetail}
        onSubmitForm={onSubmitUpdatePreSeizure}
      />
    </LayoutAdminTable>
  );
};
